import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as UserDataConfig from '../../config/user-data.config';
import { UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';

@Component({
  selector: 'app-user-registration',
  templateUrl: './user-registration.component.html',
  styleUrls: ['./user-registration.component.scss']
})
export class UserRegistrationComponent implements OnInit {

  public contentData;
  registrationDetailForm: UntypedFormGroup;
  addressSeachEnabled = false;
  public userInputDetail = UserDataConfig.ElementsConfig;
  public countryConfig = this.userInputDetail.contryConfig;
  public postCodeConfig = JSON.parse(JSON.stringify(this.userInputDetail.postCodeConfig));
  constructor(private activatedRoute: ActivatedRoute,
              private fb: UntypedFormBuilder
             ) {
    this.contentData = this.activatedRoute.snapshot.data.contentData.registration;
  }

  ngOnInit() {
    this.registrationDetailForm = this.fb.group({
      addressline1: [''],
      addressline2: [''],
      addressline3: [''],
      postcode: [''],
      country: ['']
    });
    this.addressSeachEnabled = true;
  }
  onManualClick() {
    this.addressSeachEnabled = !this.addressSeachEnabled;
  }
  onAddressSeachClick() {
    this.addressSeachEnabled = !this.addressSeachEnabled;
  }
  onSelecteAddress(formattedAddress) {
    this.registrationDetailForm.controls['addressline1'].setValue(formattedAddress[0]['addressLine1']);
    this.registrationDetailForm.controls['addressline2'].setValue(formattedAddress[1]['addressLine2']);
    this.registrationDetailForm.controls['addressline3'].setValue(formattedAddress[2]['addressLine3']);
    this.postCodeConfig.defaultValue = formattedAddress[5]['postalCode'];
    this.registrationDetailForm.controls['country'].setValue(formattedAddress[6]['country']);
    this.addressSeachEnabled = false;
  }
}
